import {PurchasesPackage} from '@revenuecat/purchases-capacitor';
import {Browser} from '@capacitor/browser';
import {isNativePlatform, nativePlatform} from './platform';

let configured = false;
let configuring: Promise<boolean> | undefined;

async function configurePurchases() {
  if (!isNativePlatform()) return false;
  if (configuring) return configuring;
  configuring = (async () => {
    const key =
      nativePlatform() === 'ios'
        ? (import.meta.env.VITE_REVENUECAT_IOS_KEY as string | undefined)
        : (import.meta.env.VITE_REVENUECAT_ANDROID_KEY as string | undefined);
    if (!key) return false;
    const {Purchases} = await import('@revenuecat/purchases-capacitor');
    await Purchases.configure({apiKey: key});
    configured = true;
    return true;
  })();
  return configuring;
}

export async function identifyPurchaser(userId: number | string) {
  if (!(await configurePurchases())) return false;
  const {Purchases} = await import('@revenuecat/purchases-capacitor');
  await Purchases.logIn({appUserID: String(userId)});
  return true;
}

export async function availableNativePackages(): Promise<PurchasesPackage[]> {
  if (!(await configurePurchases())) return [];
  const {Purchases} = await import('@revenuecat/purchases-capacitor');
  const offerings = await Purchases.getOfferings();
  return offerings.current?.availablePackages ?? [];
}

export async function purchaseNativePackage(aPackage: PurchasesPackage) {
  if (!configured) throw new Error('The native store is not configured.');
  const {Purchases} = await import('@revenuecat/purchases-capacitor');
  return Purchases.purchasePackage({aPackage});
}

export async function restoreNativePurchases() {
  if (!(await configurePurchases())) {
    throw new Error('The native store is not configured.');
  }
  const {Purchases} = await import('@revenuecat/purchases-capacitor');
  return Purchases.restorePurchases();
}

export async function openNativeSubscriptionManagement() {
  if (!(await configurePurchases())) {
    throw new Error('The native store is not configured.');
  }
  const {Purchases} = await import('@revenuecat/purchases-capacitor');
  const {customerInfo} = await Purchases.getCustomerInfo();
  if (!customerInfo.managementURL) {
    throw new Error('No subscription-management link is available.');
  }
  await Browser.open({url: customerInfo.managementURL});
}

export async function logOutPurchaser() {
  if (!configured) return;
  const {Purchases} = await import('@revenuecat/purchases-capacitor');
  await Purchases.logOut();
}
